<!--
 * @Description: viewer
 * @Autor: lijinpeng
 * @Date: 2021-12-15 14:25:17
 * @LastEditors: lijinpeng
-->
<template>
  <div ref="root">
    <slot :images="images" :options="options" />
  </div>
</template>

<script>
import Viewer from 'viewerjs';

export default {
  name: 'NfViewer',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    rebuild: {
      type: Boolean,
      default: false,
    },
    trigger: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      $viewer: null,
    };
  },
  watch: {
    '$props.images': {
      handler() {
        this.$nextTick(() => this.changeViewer());
      },
      deep: true,
    },
    '$props.trigger': {
      handler() {
        this.$nextTick(() => this.changeViewer());
      },
      deep: true,
    },
    '$props.options': {
      handler() {
        this.$nextTick(() => this.changeViewer());
      },
      deep: true,
    },
  },
  mounted() {
    this.createViewer();
  },
  destroy() {
    this.destroyViewer();
  },
  methods: {
    // 创建viewer
    createViewer() {
      this.$viewer = new Viewer(this.$refs.root, {
        zIndex: 99999,
        ...this.$props.options,
      });
      this.$emit('inited', this.$viewer);
    },
    // 销毁viewer
    destroyViewer() {
      this.$viewer && this.$viewer.destroy();
    },
    // 重建viewer
    rebuildViewer() {
      this.destroyViewer();
      this.createViewer();
    },
    // 更新viewer
    updateViewer() {
      if (this.$viewer) {
        this.$viewer.update();
        this.$emit('inited', this.$viewer);
      } else {
        this.createViewer();
      }
    },
    // change
    changeViewer() {
      if (this.$props.rebuild) {
        this.rebuildViewer();
      } else {
        this.updateViewer();
      }
    },
  },
};
</script>
